/* eslint-disable import/prefer-default-export */
import { MutationHookOptions } from '@apollo/client'
import { useCallback } from 'react'

import {
  CountTestimonialsDocument,
  PaginatedTestimonialsDocument,
  useCreateTestimonialMutation,
} from '~generated/hooks'
import { CreateTestimonialMutation, CreateTestimonialMutationVariables } from '~generated/operations'
import { CreateTestimonialInput } from '~generated/types'

export function useCreateTestimonial(
  baseOptions?: MutationHookOptions<CreateTestimonialMutation, CreateTestimonialMutationVariables>
) {
  const [createTestimonialMutation, options] = useCreateTestimonialMutation(baseOptions)

  const createTestimonial = useCallback(
    (input?: CreateTestimonialInput) => {
      return createTestimonialMutation({
        refetchQueries: [CountTestimonialsDocument, PaginatedTestimonialsDocument],
        awaitRefetchQueries: true,
        variables: { input },
      })
    },
    [createTestimonialMutation]
  )

  return [createTestimonial, options] as const
}
